import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const DocumentReducer = createSlice({
  name: "Document",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("DocumentReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = DocumentReducer;
export const { defaultAction } = actions;
export default reducer;
